import React, { useEffect,useState } from 'react';
import Image from 'next/image';
import * as PropTypes from 'prop-types';

import { useInnerWidth } from 'hooks';

import { isImageExist } from '../../utils';

import { GenericCompanyLogo } from './genericLogo';
import { CompanyLogoSkeleton } from './logoSkeleton';

const CompanyLogo = ({
  companyLogo,
  companyName,
  className,
  size,
  imgWidth,
  imgHeight,
  objectFit,
}) => {
  const [isError, setIsError] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  const width = useInnerWidth();

  useEffect(() => {
    let isMounted = true;

    const check = async () => {
      const { status } = await isImageExist(companyLogo);

      if (isMounted) {
        if (status === 'error') {
          setIsError(true);
        }

        setIsChecking(false);
      }
    };
    if (companyLogo) {
      check();
    } else {
      setIsChecking(false);
      setIsError(true);
    }

    return () => {
      isMounted = false;
    };
  }, [companyLogo]);

  const getSize = () => {
    switch (size) {
      case 'xsmall':
        return 40;

      case 'small':
        return 50;

      case 'xmedium':
        return 55;

      case 'medium':
        return 70;

      case 'xlarge':
        return 100;

      case 'large':
        return width <= 991 ? 80 : 140;

      default:
        return '100%';
    }
  };

  if (!isChecking) {
    if (!isError && companyLogo) {
      return (
        <div
          className={`generic-company-logo ${size} ${className} d-flex align-items-center justify-content-center`}
        >
          <Image
            src={companyLogo}
            loader={() => companyLogo}
            alt={`${companyName} logo`}
            width={getSize()}
            height={getSize()}
            objectFit={objectFit}
          />
        </div>
      );
    }
    return (
      <GenericCompanyLogo
        className={className}
        size={size}
        companyName={companyName}
        imgWidth={imgWidth}
        imgHeight={imgHeight}
      />
    );
  }

  return <CompanyLogoSkeleton className={className} size={size} />;
};

CompanyLogo.propTypes = {
  companyLogo: PropTypes.string,
  companyName: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(['xsmall', 'small', 'xmedium', 'medium', 'xlarge', 'large', '']),
  imgWidth: PropTypes.number,
  imgHeight: PropTypes.number,
  objectFit: PropTypes.string,
};

CompanyLogo.defaultProps = {
  companyLogo: null,
  className: '',
  size: '',
  objectFit: 'contain',
};

export default CompanyLogo;
